var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 3H4.92188C2.20789 3 0 5.20789 0 7.92188V15.8412C0 18.5552 2.20789 20.7631 4.92188 20.7631H5.65228H10.1805H19.0781C21.7921 20.7631 24 18.5552 24 15.8412V7.92188C24 5.20789 21.7921 3 19.0781 3Z",
    fill: "#6787F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 3H12V20.7631H19.0781C21.7921 20.7631 24 18.5552 24 15.8412V7.92188C24 5.20789 21.7921 3 19.0781 3Z",
    fill: "#38478A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36377 21.7996L10.1806 20.7632L9.36377 21.7996Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.77753H18.0881L22.4888 4.37677C21.6035 3.52478 20.4011 3 19.0781 3H17.8995L15.1051 5.79437V3H8.89508V5.79437L6.10071 3H4.92188C3.59894 3 2.39648 3.52478 1.51117 4.37677L5.91193 8.77753H0V14.9875H5.91193L1.67633 19.223L1.51208 19.3872C2.3974 20.2388 3.59949 20.7631 4.92188 20.7631H5.65228L5.85077 21.0148L8.81964 18.0458L8.77148 20.7631H15.1049V17.9784L17.8804 20.7631H19.0781C20.3948 20.7631 21.5923 20.2434 22.4764 19.3984L22.3109 19.2321L18.0804 14.9875H24V8.77753Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.77753H18.0881L22.4888 4.37677C21.6035 3.52478 20.4011 3 19.0781 3H17.8995L15.1051 5.79437V3H12V20.7631H15.1049V17.9784L17.8804 20.7631H19.0781C20.3948 20.7631 21.5923 20.2434 22.4764 19.3984L22.3109 19.2321L18.0804 14.9875H24V8.77753Z",
    fill: "#C7D3ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6987 10.1838V3H10.3013V10.1838H0V13.5813H10.3013L10.1805 20.7631H13.6987V13.5813H24V10.1838H13.6987Z",
    fill: "#FF337A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6987 10.1838V3H12V20.7631H13.6987V13.5813H24V10.1838H13.6987Z",
    fill: "#D1005B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36359 9.24622V8.25195L4.16925 3.05762C3.6366 3.13965 3.13177 3.30756 2.66943 3.54651L8.36932 9.24622H9.36359Z",
    fill: "#FF337A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3304 3.54651C20.868 3.30756 20.3632 3.13965 19.8306 3.05762L14.6362 8.25195V9.24622H15.6305L21.3304 3.54651Z",
    fill: "#D1005B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6709 20.2172C3.13342 20.4559 3.63824 20.6237 4.17108 20.7057L9.36377 15.5128V14.5186H8.36951L2.6709 20.2172Z",
    fill: "#FF337A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6362 14.5186V15.5157L19.8112 20.7083C20.3449 20.6281 20.851 20.4622 21.3146 20.2247L15.6277 14.5186H14.6362Z",
    fill: "#D1005B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishNew);
export default __webpack_public_path__ + "static/media/EnglishNew.b7226a31.svg";
export { ForwardRef as ReactComponent };